import api from './api';

export type VerificationChannel = 'email' | 'phone';

interface VerificationPayload {
  user_id: number;
  channel: VerificationChannel;
  code?: string;
}

export interface VerificationResponse {
  message: string;
}

class ContactVerificationClient {
  constructor(private http = api) {}

  async sendCode(userId: number, channel: VerificationChannel): Promise<VerificationResponse> {
    const payload: VerificationPayload = {
      user_id: userId,
      channel,
    };
    const response = await this.http.post<VerificationResponse>('/api/auth/send-verification-code', payload);
    return response.data;
  }

  async verifyCode(userId: number, channel: VerificationChannel, code: string): Promise<VerificationResponse> {
    const payload: VerificationPayload = {
      user_id: userId,
      channel,
      code,
    };
    const response = await this.http.post<VerificationResponse>('/api/auth/verify-code', payload);
    return response.data;
  }
}

const defaultClient = new ContactVerificationClient();

class VerificationChannelController {
  constructor(
    private readonly userId: number,
    private readonly channel: VerificationChannel,
    private readonly client: ContactVerificationClient,
  ) {}

  sendCode(): Promise<VerificationResponse> {
    return this.client.sendCode(this.userId, this.channel);
  }

  verifyCode(code: string): Promise<VerificationResponse> {
    return this.client.verifyCode(this.userId, this.channel, code);
  }
}

export class ContactVerificationManager {
  private readonly client: ContactVerificationClient;

  constructor(private readonly userId: number, client: ContactVerificationClient = defaultClient) {
    this.client = client;
  }

  forChannel(channel: VerificationChannel): VerificationChannelController {
    return new VerificationChannelController(this.userId, channel, this.client);
  }
}

export const createContactVerificationManager = (userId: number): ContactVerificationManager =>
  new ContactVerificationManager(userId);
